<template>
  <div class="map-vedio-box" :id="vedioBox">
    <div class="load-top-left">
      
      <a-tooltip placement="top" title="全屏" v-if="!fullscreenflag">
        
        <div @click="fullscreen" style="margin-right: 5px; cursor: pointer" class="icon-box"
          ><ExpandOutlined
        /></div>
      </a-tooltip>
      <a-tooltip placement="top" title="取消全屏" v-if="fullscreenflag">
        <span
        class="icon-box"
          @click="cancelFullScreen"
          style="margin-right: 5px; cursor: pointer"
          ><CompressOutlined
        /></span>
      </a-tooltip>
    </div>
    <div class="load-top">
      <a-tooltip placement="top" title="开始直播" v-if="!videoShow">
        <span class="icon-box" @click="planvedio(0)" style="margin-right: 5px; cursor: pointer">
          <PlayCircleOutlined />
        </span>
      </a-tooltip>
      <a-tooltip placement="top" title="停止直播" v-if="videoShow">
        <span class="icon-box" @click="onStop" style="margin-right: 5px; cursor: pointer"
          ><PoweroffOutlined
        /></span>
      </a-tooltip>
      <a-tooltip placement="top" title="刷新">
        <span class="icon-box" @click="reloadVedio" style="margin-right: 5px; cursor: pointer"
          ><ReloadOutlined
        /></span>
      </a-tooltip>

      <a-tooltip
        placement="top"
        title="清晰度"
        :visible="clarityShowText"
        @visibleChange="handleClickChangeText"
      >
        <span class="icon-box" style="cursor: pointer" @click="openClarity"
          ><SettingOutlined
        /></span>
      </a-tooltip>
      <div v-show="clarityShow">
        <a-popover
          :visible="clarityShow"
          placement="bottom"
          color="black"
          trigger="click"
          @visibleChange="handleClickChange"
        >
          <template #content>
            <div
              v-for="(item, index) in clarityList"
              :key="index"
              class="claritybox"
              style="cursor: pointer; color: #fff"
            >
              <span
                @click="clickClarity(item.value)"
                :class="qualitys == item.value ? 'select-clarity' : ''"
                :style="{ color: qualitys == item.value ? '#5cadff' : '#fff' }"
                >{{ item.label }}</span
              >
            </div>
          </template>
        </a-popover>
      </div>
    </div>
    <div class="load-vedio">
      <a-tooltip placement="top" title="机场">
        <div
          class="load-vedio-item"
          :style="{ background: vedioClick == 0 ? '#1890FF' : '' }"
          @click="planvedio(0)"
          v-if="checkDockSn"
        >
          <span>H</span>
          <!-- <span>机场</span> -->
        </div>
      </a-tooltip>
      <a-tooltip placement="top" title="飞行相机">
        <div
          class="load-vedio-item"
          style="margin-left: 2px"
          :style="{ background: vedioClick == 1 ? '#1890FF' : '' }"
          @click="planvedio(1)"
          v-if="flycameraFlag && planMode > -1"
        >
          <span>F</span>
          <!-- <span>飞行相机</span> -->
        </div>
      </a-tooltip>
      <a-tooltip placement="top" title="负载相机">
        <div
          class="load-vedio-item"
          style="margin-left: 2px"
          :style="{ background: vedioClick == 2 ? '#1890FF' : '' }"
          @click="planvedio(2)"
          v-if="planMode > -1"
        >
          <span>C</span>
          <!-- <span>负载相机</span> -->
        </div>
      </a-tooltip>
    </div>
    <div class="load-auth" v-show="vedioClick == 2">
      <a-tooltip placement="top">
        <template #title>
          <span>负载控制</span>
        </template>
        <div @click="onAuthPayload" style="cursor: pointer;" class="icon-box">
          <img src="../../assets/icons/photowhite.png" alt="" style="width: 20px" />
        </div>
      </a-tooltip>
    </div>
    <div style="width: 100%; height: 100%" @dblclick="aimVedio" :style="{ cursor: vedioClick == 2 ? 'crosshair' : '' }">
      <a-spin tip="加载中" :spinning="vedio1spinning" v-if="checkDockSn">
        <div style="width: 100%; height: 100%" v-show="videoShow">
          <video
            style="
              width: 100%;
              height: 100%;
              object-fit: fill;
              border-radius: 10px;
            "
            id="video-webrtc-center"
            ref="videowebrtccenter"
            autoplay
          ></video>
          <!-- controls -->
        </div>
        <div v-show="!videoShow" class="no-vedio">
          <!-- 暂无视频 -->
        </div>
      </a-spin>
    </div>
    <!-- 飞行过程中途径的工地名称 -->
    <div class="construction-box1"  v-if="vedioClick == 2">
      <div class="construction-item-box1" v-if="constructionList && constructionList.length > 0">
          <div class="construction-item1" v-for="(item,index) in constructionList" :key="index" :title="item.name">
            <span v-if="item.name">工地名称：</span>
            {{item.name}}
          </div>
      </div>
    </div>
    <!-- X 坐标系 -->
    <div class="coordinate-system-box-x1" v-if="vedioClick == 2">
          <div class="coordinate-system1">
            <div class="x-axis1">
              <div
                :class="
                  Math.abs(item.num) % 10 == 0 ? 'x-tickmarks-z1' : 'x-tickmarks1'
                "
                :style="{ left: getLeft(item.num) }"
                v-for="(item, index) in rodXList"
                :key="index"
              >
                {{ item.num }}
              </div>
              <div class="x-tickmarks-active1" :style="{ left: getLeft(gimbalInfos.gimbal_x) }">
                {{ gimbalInfos.gimbal_x }}
              </div>
            </div>
          </div>
        </div>
        <!-- Y 坐标系 -->
        <div class="coordinate-system-box-y1" v-if="vedioClick == 2" :style="{left: showPayload ? '90px' :'40px'}">
          <div style="height: 20%"></div>
          <div class="coordinate-system-y1">
            <div class="y-axis1">
              <div
                :class="
                  Math.abs(item.num) % 10 == 0 ? 'y-tickmarks-z1' : 'y-tickmarks1'
                "
                :style="{
                  bottom: getBottom(item.num),
                  width: Math.abs(item.num) >= 100 ? '30px' : '25px',
                }"
                v-for="(item, index) in rodYList"
                :key="index"
              >
                <div class="y-num-txts1">
                  {{ item.num }}
                </div>
              </div>
              <div class="y-tickmarks-active1" :style="{ bottom: getBottom(gimbalInfos.gimbal_y) }">
                <div class="y-num-txts1">{{ gimbalInfos.gimbal_y }}</div>
              </div>
            </div>
          </div>
        </div>
    <!-- 测距距离 当飞机在线、有距离、视频播放的时候显示 -->
    <div class="measure-distance" v-if="planMode > -1 && measureDistance && videoShow">
      <div>{{ measureDistance }}</div>
    </div>
    
    <!-- 云台 -->
    <div class="gimbal-box" v-show="vedioClick == 2 && showPayload">
      <!-- 点击重置云台后显示云台选项  -->
      <div class="gimbal-option" v-show="gimbalResetPopoverData.visible">
        <div
          v-for="(item, index) in GimbalResetModeOptions"
          :key="index"
          class="gimbal-option-item"
          :style="{
            border:
              gimbalResetPopoverData.resetMode == item.value
                ? '1px solid #fff'
                : '',
          }"
        >
          <a-tooltip placement="right">
            <template #title>
              <span>{{ item.label }}</span>
            </template>
            <div @click="gimbalClick(item.value)" style="cursor: pointer">
              <img
                src="../../assets/icons/yuntaiblue1.png"
                alt=""
                style="width: 20px"
                v-if="item.value == 0"
              />
              <img
                src="../../assets/icons/yuntaiblue2.png"
                alt=""
                style="width: 20px"
                v-if="item.value == 1"
              />
              <img
                src="../../assets/icons/yuntaiblue3.png"
                alt=""
                style="width: 20px"
                v-if="item.value == 2"
              />
              <img
                src="../../assets/icons/yuntaiblue4.png"
                alt=""
                style="width: 20px"
                v-if="item.value == 3"
              />
            </div>
          </a-tooltip>
        </div>
      </div>
      <a-tooltip placement="right">
        <template #title>
          <span>云台控制</span>
        </template>
        <div @click="onShowGimbalResetPopover" style="cursor: pointer">
          <img
            src="../../assets/icons/yuntai1.png"
            alt=""
            style="width: 20px"
          />
        </div>
        <!-- 禁用 -->
        <!-- <div style="cursor: not-allowed" v-else>
          <img src="../../assets/icons/yuntai.png" alt="" style="width: 20px" />
        </div> -->
      </a-tooltip>
    </div>
    <!-- 变焦 -->
    <div class="zoom-box" v-show="vedioClick == 2 && showPayload">
      <div
        style="margin-bottom: 8px"
        v-for="(item, index) in ZoomCameraTypeOptions"
        :key="index"
      >
        <!-- <Button
          size="small"
          :type="cameraType == item.value ? 'primary' : ''"
          ghost
          @click="zoomClick(item.value)"
        >
          <span>{{ item.label }}</span>
        </Button> -->
        <div
          class="zoom-btn"
          @click="zoomClick(item.value)"
          :class="cameraType == item.value ? 'zoom-btn-active' : ''"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
    <!-- 右边 开始录像，结束录像，变焦 -->
    <div class="load-right" v-show="vedioClick == 2 && showPayload">
      <div>
        <div class="ml10 mb8" v-show="photoShow">
          <a-tooltip placement="left">
            <template #title>
              <span>切换至录像</span>
            </template>
            <!-- :disabled="planeStatus" -->
            <div @click="photoChange(false)" style="cursor: pointer" @mouseenter="photoEnter" @mouseleave="photoLeave">
              <img
                src="../../assets/icons/qiehuan.png"
                alt=""
                style="width: 20px"
                v-if="photoFlag"
              />
              <img
                src="../../assets/icons/qiehuanwhite.png"
                alt=""
                style="width: 20px"
                v-else
              />
              
            </div>
            <!-- 禁用 -->
            <!-- <div style="cursor: not-allowed" v-else>
              <img
                src="../../assets/icons/qiehuangpai.png"
                alt=""
                style="width: 20px"
              />
            </div> -->
          </a-tooltip>
        </div>
        <div class="ml10 mb8" v-show="!photoShow">
          <a-tooltip placement="left">
            <template #title>
              <span>切换至照相</span>
            </template>
            <div @click="photoChange(true)" style="cursor: pointer" @mouseenter="photoEnter" @mouseleave="photoLeave">
              <img
                src="../../assets/icons/qiehuan.png"
                alt=""
                style="width: 20px"
                v-if="photoFlag"
              />
              <img
                src="../../assets/icons/qiehuanwhite.png"
                alt=""
                style="width: 20px"
                v-else
              />
            </div>
            <!-- 禁用 -->
            <!-- <div style="cursor: not-allowed" v-else>
              <img
                src="../../assets/icons/qiehuangshi.png"
                alt=""
                style="width: 20px"
              />
            </div> -->
          </a-tooltip>
        </div>
        <!--  -->
        <div class="ml10 mb8" v-show="photoShow">
          <a-tooltip placement="left">
            <template #title>
              <span>拍照</span>
            </template>
            <div @click="onTakeCameraPhoto" style="cursor: pointer">
              <img
                src="../../assets/icons/paizhaos.png"
                alt=""
                style="width: 20px"
              />
            </div>
            <!-- 禁用 -->
            <!-- <div style="cursor: not-allowed" v-else>
              <img
                src="../../assets/icons/paizhao.png"
                alt=""
                style="width: 20px"
              />
            </div> -->
          </a-tooltip>
        </div>
        <div v-show="!photoShow">
          <div class="ml10 mb8" v-show="startVedio">
            <!-- <Button size="small" ghost @click="onStartCameraRecording">
                  <span>开始录制</span>
                </Button> -->
            <a-tooltip placement="left">
              <template #title>
                <span>开始录制</span>
              </template>
              <div @click="onStartCameraRecording" style="cursor: pointer">
                <img
                  src="../../assets/icons/starts.png"
                  alt=""
                  style="width: 20px"
                />
              </div>
              <!-- <div v-else style="cursor: not-allowed">
                <img
                  src="../../assets/icons/shiping.png"
                  alt=""
                  style="width: 20px"
                />
              </div> -->
            </a-tooltip>
          </div>
          <div class="ml10" v-show="!startVedio">
            <!-- <Button size="small" ghost @click="onStopCameraRecording">
                  <span>停止录制</span>
                </Button> -->
            <a-tooltip placement="left">
              <template #title>
                <span>停止录制</span>
              </template>
              <div @click="onStopCameraRecording" style="cursor: pointer">
                <img
                  src="../../assets/icons/stops.png"
                  alt=""
                  style="width: 20px"
                />
              </div>
              <!-- <div style="cursor: not-allowed" v-else>
                <img
                  src="../../assets/icons/shiping.png"
                  alt=""
                  style="width: 20px"
                />
              </div> -->
            </a-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div
      class="zoom-slider"
      v-show="vedioClick == 2 && showPayload && cameraType != 'wide'"
    >
      <a-tooltip placement="left">
        <template #title>
          <div>{{ zoomFactor }}</div>
        </template>
        <div style="width: 3px"></div>
        <a-slider
          v-model:value="zoomFactorPopoverData.zoomFactor"
          :step="10"
          :tooltip-visible="false"
          @change="zoomSlider"
          vertical
          :marks="zoomFactorPopoverData.zoomMarks"
          :min="2"
          :max="200"
        />
      </a-tooltip>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, reactive, onMounted, onUnmounted } from "vue";
import jswebrtc from "/@/vendors/jswebrtc.min.js";
import {
  PoweroffOutlined,
  SettingOutlined,
  PlayCircleOutlined,
  ReloadOutlined,
  ExpandOutlined,
  CompressOutlined,
} from "@ant-design/icons-vue";
import {
  GimbalResetMode,
  GimbalResetModeOptions,
  LostControlActionInCommandFLightOptions,
  WaylineLostControlActionInCommandFlightOptions,
} from "/@/types/drone-control";
import {
  startLivestream,
  getVedioList,
  changeLivestreamLens,
  setLivestreamQuality,
  stopLivestream,
} from "/@/api/manage";
import { CURRENT_CONFIG as config } from "/@/api/http/config";
import { message, Button } from "ant-design-vue";
import { ControlSource, DeviceOsdCamera } from "/@/types/device";
import { usePayloadControl } from "./use-payload-control";
import { useDroneControlWsEvent } from "./use-drone-control-ws-event";
import { useMyStore } from "/@/store";
import mittBus from "/@/event-bus/mittBus";
import { ELocalStorageKey, EDeviceTypeName } from "/@/types";

import {
  CameraMode,
  CameraType,
  CameraTypeOptions,
  ZoomCameraTypeOptions,
  CameraListItem,
} from "/@/types/live-stream";
const props = defineProps({
  // 飞机 sn
  checkPlaneSn: {
    type: String,
    default: () => {
      return "";
    },
  },
  // 机场 sn
  checkDockSn: {
    type: String,
    default: () => {
      return "";
    },
  },
  // 机场 状态
  checkPlaneMode: {
    type: Number,
    default: () => {
      return -1;
    },
  },
  //   负载控制
  payloads: {
    type: Object,
  },
  //   控制面板传递过来的参数 没有用
  toVedioDatas: {
    type: Object,
  },
  // 机场实时数据
  deviceInfo: {
    type: Object,
  },
});
const store = useMyStore();
// 视频加载loading
const vedio1spinning = ref<boolean>(false);
// 视频播放的sn\type\id\清晰度
const vedioSn = ref<string>("");
const vedioType = ref<string>("");
const vedioId = ref<string>("");
const qualitys = ref<number>(1);
// s视频div
const videowebrtccenter = ref(null);
// 是否显示视频 true为显示视频 false为不显示视频，显示暂无视频
const videoShow = ref<boolean>(false);
// 选择清晰度 显示,false不显示,true显示
const clarityShow = ref<boolean>(false);
// 选择清晰度 tooltip文字 显示,false不显示,true显示
const clarityShowText = ref<boolean>(false);
// 是否全屏 true为全屏、false不是全屏
const fullscreenflag = ref<boolean>(false);
// 飞机状态，默认为-1 离线，0为空闲
const planMode = ref<number>(-1);
const vedioBox = ref();
// 测距距离
const measureDistance = ref<any>(0);
// 选中的视频
const vedioClick = ref<number>(-1);
const flycameraFlag = ref<boolean>(true) // 飞行相机是否显示 true显示 false不显示
// 鼠标移入 true变蓝色，false 白色
const photoFlag = ref<boolean>(false)
// Y 轴
const rodYList = ref<any>([]);
// x 轴
const rodXList = ref<any>([]);
// 飞行过程中，途径的工地列表
const constructionList = ref<any>([])
const gimbalInfos = reactive({
  gimbal_y: 0, //云台俯仰轴角度
  gimbal_x: 0, //云台偏航轴角度
})
const clarityList = [
  {
    value: 0,
    label: "自适应",
  },
  {
    value: 1,
    label: "流畅",
  },
  {
    value: 2,
    label: "标准",
  },
  {
    value: 3,
    label: "高清",
  },
  {
    value: 4,
    label: "超清",
  },
];
// 飞机状态不为空闲时，跳到M30相机，只跳一次
const modelType = ref<boolean>(true);
// 变蓝色
function photoEnter() {
  photoFlag.value = true
}
// 变白色
function photoLeave() {
  photoFlag.value = false
}
const stopWatchList = ref<any>([]) // 停止 watch
onMounted(() => {
  stopWatchList.value = []
  modelType.value = true;
  // console.log('vedioele',videowebrtccenter.value);
  // console.log(4699, props.checkDockSn);
  getYList(15)
  getXlist(15)
  vedioBox.value = props.checkDockSn;
});
// 监听机场状态，获取测距距离
stopWatchList.value.push(
watch(
  () => props.deviceInfo,
  (data) => {
    if (data) {      
      // 获取测距距离
      if (
        data?.device?.payloads &&
        data?.device?.payloads[0]?.measure_target_distance
      ) {
        if (data.device.payloads[0].measure_target_distance < 1000) {
          measureDistance.value = data.device.payloads[0].measure_target_distance?.toFixed(2);
        }
      }else{
        measureDistance.value = 0
      }
    }
  },
  {
    deep: true,
  }
)
)

// 飞行过程中途径的工地 列表
stopWatchList.value.push(
watch(()=>store?.state?.construction?.data,(data)=>{
  if(data && data.length > 0){
    let arr = [] as any
    // console.log(600000,data,props.checkPlaneSn);
    
    data.map((item:any)=>{
      if (item.sn === props.checkPlaneSn) { 
        // console.log(604444,item);
        
        arr.push({
          name: item?.constructionSite?.prs_name
        })
      }
    })
    constructionList.value = arr
  }else{
    constructionList.value = []
  }

})
)
stopWatchList.value.push(
watch(()=>store?.state.deviceState,(data)=>{
  if (data) {
    // 机场
    if (
      data.currentType === EDeviceTypeName.Dock &&
      data.dockInfo[data.currentSn]
    ){
      const planeSn = props.checkPlaneSn
      const deviceAll = data.deviceInfo[planeSn] as any;
      // console.log(25555,planeSn,deviceAll);
      // y轴
      if (deviceAll && deviceAll.payloads && deviceAll.payloads.length > 0) {
        const devicePayloads = deviceAll.payloads[0]
        // console.log(55577,planeSn,devicePayloads);
        
        if (devicePayloads?.gimbal_pitch) {
          const num = devicePayloads.gimbal_pitch.toFixed(1)
          gimbalInfos.gimbal_y = parseFloat(num)
          if (gimbalInfos.gimbal_y >= 45 ) {
            gimbalInfos.gimbal_y = 45
          }
          if (gimbalInfos.gimbal_y <= -120 ) {
            gimbalInfos.gimbal_y = -120
          }
        }else{
          gimbalInfos.gimbal_y = 0
        }
        if (devicePayloads?.gimbal_yaw && deviceAll?.attitude_head) {
          const nums = (devicePayloads.gimbal_yaw - deviceAll.attitude_head).toFixed(1)
          gimbalInfos.gimbal_x = parseFloat(nums)
          if (gimbalInfos.gimbal_x >= 90) {
            gimbalInfos.gimbal_x = 90
          }
          if (gimbalInfos.gimbal_x <= -90) {
            gimbalInfos.gimbal_x = -90
          }
        }else{
          gimbalInfos.gimbal_x = 0
        }
      }else{
        gimbalInfos.gimbal_y = 0
        gimbalInfos.gimbal_x = 0
      }
    }
    // console.log(55588,props.dovkVedioSn,gimbalInfos);
    
  }
},{
  deep: true,
})
)
// 监听飞机状态
stopWatchList.value.push(
watch(
  () => store?.state.deviceState,
  (data) => {
    if (data) {
      // 机场数据
      // const oneDockInfo = data?.dockInfo[props.checkDockSn]
      // 飞机数据
      const oneDeviceInfo = data?.deviceInfo[props.checkPlaneSn];
      // console.log(13677,oneDockInfo,oneDeviceInfo);

      //       onlineVedioData.value.map((onItem:any)=>{
      //         // 机场状态
      //         if (onItem.dockSn == item?.gateway?.sn) {
      //           onItem.dockStatus = oneDockInfo?.basic_osd?.mode_code
      //         }
      // 飞机状态
      if (oneDeviceInfo) {
        planMode.value = oneDeviceInfo?.mode_code;
      } else {
        planMode.value = -1;
      }
    }
  },
  {
    deep: true,
  }
)
)
// 飞机状态
stopWatchList.value.push(
watch(
  () => planMode.value,
  async (modes) => {
    if (videoShow.value) {
      // 当飞机在线时，跳到机场视频 飞机状态不为空闲时，跳到M30相机，只跳一次
      if (modes > 0) {
        if (modelType.value) {
          modelType.value = false;
          if (vedioClick.value == 2) {
            return;
          }
          await playVedioList(2);
          vedioClick.value = 2;
        }
      } else {
        if (vedioClick.value == 0) {
          return;
        }
        await playVedioList(0);
        vedioClick.value = 0;
      }
    }
  }
)
)
// 机场sn
stopWatchList.value.push(
watch(
  () => props.checkDockSn,
  async (dockSn) => {
    if (dockSn) {
      if (videoShow.value) {
        // 当飞机在线时，跳到机场视频 飞机状态不为空闲时，跳到M30相机，只跳一次
        if (planMode.value && planMode.value > 0) {
          if (modelType.value) {
            modelType.value = false;
            if (vedioClick.value == 2) {
              return;
            }
            await playVedioList(2);
            vedioClick.value = 2;
          }
        } else {
          if (vedioClick.value == 0) {
            return;
          }
          await playVedioList(0);
          vedioClick.value = 0;
        }
      }
    }
  }
)
)
// 获取 x 轴距离起点的位置
function getBottom(val: number) {
  let num = val + 120;
  let numRate = (num / 165) * 100 + "%";
  return numRate;
}
// 获取 x 轴距离起点的位置
function getLeft(val: number) {
  let num = val + 90;
  let numRate = (num / 180) * 100 + "%";
  return numRate;
}
// 水平值
function getXlist(step: number) {
  // let step = 15;
  let start = -90;
  let end = 90;
  let num = (end - start) / step;
  rodXList.value = [];
  for (let i = 0; i <= num; i++) {
    rodXList.value.push({
      num: start + step * i,
    });
  }
}
// 垂直值
function getYList(step: number) {
  // let step = 15; //步长
  let start = -120; //开始
  let end = 45; //结束
  let num = (end - start) / step;
  rodYList.value = [];
  for (let i = 0; i <= num; i++) {
    rodYList.value.push({
      num: start + step * i,
    });
  }
}
function getResize() {
  const div = document.getElementById(`${props.checkDockSn}`) as any;
  let xStep = 15;
  let yStep = 15;
  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const width = entry.contentRect.width;
      const height = entry.contentRect.height;
      // console.log(3233,width, height);
      if (width >= 700) {
        xStep = 15;
      }
      if (width < 700 && width > 300) {
        xStep = 20;
      }
      if (width < 300) {
        xStep = 30;
      }
      if (height >= 700) {
        yStep = 15;
      }
      if (height < 700 && height > 300) {
        yStep = 20;
      }
      if (height < 300) {
        yStep = 30;
      }
      // 处理宽度和高度变化的逻辑
    }
    getYList(yStep);
    getXlist(xStep);
  });
  if (div) {
    resizeObserver.observe(div);
  }
}
// 点击视频按钮
function planvedio(val: number) {
  vedioClick.value = val;
  playVedioList(val);
  if (val == 2) {
    getResize()
  }
}
// 负载控制
const payloadSelectInfo = {
  value: null as any,
  controlSource: undefined as undefined | ControlSource,
  options: [] as any,
  payloadIndex: "" as string,
  camera: undefined as undefined | DeviceOsdCamera, // 当前负载osd信息
};
// 负载按钮显示 点击负载按钮成功后显示  默认是false
const showPayload = ref<boolean>(false);
const {
  checkPayloadAuth,
  authPayload,
  resetGimbal,
  switchCameraMode,
  takeCameraPhoto,
  startCameraRecording,
  stopCameraRecording,
  changeCameraFocalLength,
  cameraAim,
} = usePayloadControl();
// 更新负载信息
stopWatchList.value.push(
watch(
  () => props.payloads,
  (payloads) => {
    if (payloads && payloads.length > 0) {
      // console.log(6255, payloads);
      payloadSelectInfo.value = payloads[0].payload_sn;
      payloadSelectInfo.controlSource =
        payloads[0].control_source || ControlSource.B;
      payloadSelectInfo.payloadIndex = payloads[0].payload_index || "";
      payloadSelectInfo.options = payloads.map((item: any) => ({
        label: item.payload_name,
        value: item.payload_sn,
      }));
      payloadSelectInfo.camera = undefined;
    } else {
      payloadSelectInfo.value = null;
      payloadSelectInfo.controlSource = undefined;
      payloadSelectInfo.options = [];
      payloadSelectInfo.payloadIndex = "";
      payloadSelectInfo.camera = undefined;
    }
  },
  {
    immediate: true,
    deep: true,
  }
)
)

// 云台
const gimbalResetPopoverData = reactive({
  visible: false,
  loading: false,
  resetMode: null as null | GimbalResetMode,
});
const { droneControlSource, payloadControlSource } = useDroneControlWsEvent(
  props.checkDockSn,
  payloadSelectInfo.value
);
// 变焦
// 变焦 默认值　默认值为zoom
const cameraType = ref<string>("wide");
// 焦距 滑动显示的值
const zoomFactor = ref<number>(2);
const zoomFactorPopoverData = reactive({
  visible: false,
  loading: false,
  cameraType: null as any,
  // cameraType: null  as null | CameraType,
  zoomFactor: 2 as number,
  zoomMarks: {
    2: {
      style: {
        color: "#fff",
      },
      label: "2",
    },
    40: {
      style: {
        color: "#fff",
      },
      label: "5",
    },

    80: {
      style: {
        color: "#fff",
      },
      label: "10",
    },
    120: {
      style: {
        color: "#fff",
      },
      label: "20",
    },
    200: {
      style: {
        color: "#fff",
      },
      label: "200",
    },
  },
});
// 拍照
// 相机切换，true 为拍照，false为开始录像
const photoShow = ref<boolean>(true);
// 开始录像 按钮显示 点击开始录像后，结束录像按钮显示，开始录像隐藏，反之如此
const startVedio = ref<boolean>(true);
// 映射时用来判断选中的视频类型，1为广角、2为变焦、3为红外
const zoomNum = ref<number>(1);
// 双击 视频角度切换
async function aimVedio(e: any) {
  const offsetX = e.offsetX;
  const offsetY = e.offsetY;
  const x = offsetX / e.target.offsetWidth;
  const y = offsetY / e.target.offsetHeight;
  try {
    if (vedioClick.value == 2) {
      await cameraAim(props.checkDockSn, {
        payload_index: payloadSelectInfo.payloadIndex,
        camera_type: cameraType.value,
        locked: false,
        x: x,
        y: y,
      });
    }
  } catch (error) {}
}
// 根据控制面板传递的参数进行操作
// watch(
//   () => props.toVedioDatas,
//   (datas) => {
//     // console.log(645, datas);

//     // 点击四个方位
//     if (datas?.aimDir) {
//       const dirs = datas.aimDir;
//       // console.log(648, dirs);
//       if (dirs && dirs.length > 2) {
//         const directions = dirs.substring(0, 2);
//         let x = 0;
//         let y = 0;
//         if (directions == "up") {
//           x = 0.5;
//           y = 0.45;
//         } else if (directions == "rh") {
//           x = 0.55;
//           y = 0.5;
//         } else if (directions == "dw") {
//           x = 0.5;
//           y = 0.55;
//         } else if (directions == "lf") {
//           x = 0.45;
//           y = 0.5;
//         }
//         if (vedioClick.value == 2) {
//           cameraAim(props.checkDockSn, {
//             payload_index: payloadSelectInfo.payloadIndex,
//             camera_type: cameraType.value,
//             locked: false,
//             x: x,
//             y: y,
//           });
//         }
//       }
//     }
//   },
//   {
//     deep: true,
//   }
// );
// 中间视频 无人机1
function playVedioList(val: number) {
  // 当val 为0 时显示机场的视频，1，2显示飞机的视频
  //   if (!props.checkPlaneSn || !props.checkDockSn) {
  //     return;
  //   }
  //   vedioClick.value = val
  // console.log(8077, props.checkPlaneSn, props.checkDockSn, val, vedioClick.value);

  vedioSn.value = "";
  if (val == 0) {
    vedioSn.value = props.checkDockSn;
  } else if (val == 1 || val == 2) {
    vedioSn.value = props.checkPlaneSn;
  }
  const sn = vedioSn.value;
  // console.log(1219, sn);
  if (!sn) {
    return;
  }
  // 获取视频
  getVedioList(sn).then((res) => {
    if (res.code == 0) {
      if (
        res.data &&
        res.data.cameras_list &&
        res.data.cameras_list.length > 0
      ) {
        const lengths = res.data.cameras_list
        if (lengths > 1) {
          let i = val ? val - 1 : 0;
          const type = res.data.cameras_list[i].index;
          // console.log(1120, res.data.cameras_list, type);
          vedioType.value = type;
          playVedio(sn, type);
        }else{
          const type = res.data.cameras_list[0].index;
          vedioType.value = type;
          playVedio(sn, type);
        }
      }
    }
  });
}
async function playVedio(sn: string, types: string) {
  const timestamp = new Date().getTime().toString();
  vedioId.value = sn + "/" + types + "/" + "normal-0";
  const liveURL = config.rtmpURL + timestamp;
  vedio1spinning.value = true;
  videoShow.value = false;
  await startLivestream({
    url: liveURL,
    video_id: vedioId.value,
    url_type: 1,
    video_quality: qualitys.value,
  }).then((res) => {
    if (res.code !== 0) {
      playVedio(sn, types);
      return;
    }
    const url = res.data.url;
    // const url = 'webrtc://112.19.171.189/live/123456';

    const videoElement = videowebrtccenter.value;
    console.log("videoElement:", videoElement);

    const player = new jswebrtc.Player(url, {
      video: videoElement,
      autoplay: true,
      onPlay: (obj: any) => {
        setTimeout(() => {
          vedio1spinning.value = false;
          videoShow.value = true;
          if (vedioClick.value == 2) {
            onSwitchVedio('wide')
          }
        }, 1000);
      },
    });
  });
}
// 打开选择清晰度
function openClarity() {
  clarityShow.value = !clarityShow.value;
  clarityShowText.value = false;
}
// 选择清晰度
function clickClarity(val: any) {
  qualitys.value = val;
  setLivestreamQuality({
    video_id: vedioId.value,
    video_quality: val,
  }).then((res: any) => {
    if (res.code === 0) {
      message.success("成功切换到" + clarityList[val].label);
      clarityShow.value = false;
    }
  });
}
// 清晰度 气泡框
function handleClickChange(val: boolean) {
  clarityShow.value = val;
  clarityShowText.value = false;
}
// 清晰度 气泡框 文字提示
function handleClickChangeText(val: boolean) {
  clarityShow.value = false;
  clarityShowText.value = val;
}
// 结束机场视频
function onStop() {
  stopLivestream({
    video_id: vedioId.value,
  }).then((res) => {
    if (res.code === 0) {
      message.success("停止直播成功");
      videoShow.value = false;
      vedioClick.value = -1;
    }
  });
}
// 刷新
function reloadVedio() {
  playVedioList(vedioClick.value);
}
// 全屏
function fullscreen() {
  try {
    const divElement = document.getElementById(`${vedioBox.value}`);
    // const divElement = document.querySelector('.map-vedio-box')
    console.log(864, divElement);
    // const divElement = videowebrtccenter.value
    if (!divElement) {
      return;
    }
    // 检测浏览器是否支持全屏功能
    if (divElement.requestFullscreen) {
      divElement.requestFullscreen();
    } else if (divElement.mozRequestFullScreen) {
      // Firefox
      divElement.mozRequestFullScreen();
    } else if (divElement.webkitRequestFullscreen) {
      // Chrome, Safari 和 Opera
      divElement.webkitRequestFullscreen();
    } else if (divElement.msRequestFullscreen) {
      // IE/Edge
      divElement.msRequestFullscreen();
    }
    fullscreenflag.value = true;
  } catch (error) {}
}
// 取消全屏显示
function cancelFullScreen() {
  try {
    // const divElement = document.querySelector('.map-vedio-box')
    const divElement = document.getElementById(`${vedioBox.value}`);
    if (!divElement) {
      return;
    }
    // 取消全屏显示
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari 和 Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
    fullscreenflag.value = false;
  } catch (error) {}
}
// 负载控制
async function onAuthPayload() {
  showPayload.value = !showPayload.value;
  // console.log(994,showPayload.value);
  // 当为false 时即 将两边的按钮收缩不调用接口
  if (!showPayload.value) {
    return;
  }
  const result = await authPayload(
    props.checkDockSn,
    payloadSelectInfo.payloadIndex
  );
  if (result) {
    payloadControlSource.value = ControlSource.A;
  }
}
// 点击云台重置类型
function gimbalClick(val: any) {
  gimbalResetPopoverData.resetMode = val;
  onGimbalResetConfirm(true);
}
async function onGimbalResetConfirm(confirm: boolean) {
  if (confirm) {
    if (gimbalResetPopoverData.resetMode === null) {
      // message.error("请选择云台重置模式类型");
      return;
    }
    gimbalResetPopoverData.loading = true;
    try {
      await resetGimbal(props.checkDockSn, {
        payload_index: payloadSelectInfo.payloadIndex,
        reset_mode: gimbalResetPopoverData.resetMode,
      });
    } catch (err) {}
  }
  gimbalResetPopoverData.visible = false;
}
function onShowGimbalResetPopover() {
  gimbalResetPopoverData.visible = !gimbalResetPopoverData.visible;
  gimbalResetPopoverData.loading = false;
  gimbalResetPopoverData.resetMode = null;
}
// 点击变焦
function zoomClick(val: any) {
  cameraType.value = val;
  if (val != "wide") {
    zoomFactorPopoverData.cameraType = val;
  }
  if (vedioClick.value == 2) {
    onSwitch1(val);
    // onZoomFactorConfirm(true)
  }
}
// 切换 当点击变焦或红外时，需要将视频切换到相应的状态
const onSwitch1 = (val: any) => {
  const lens = val;
  const sn = vedioSn.value;
  const type = vedioType.value;
  vedioId.value = sn + "/" + type + "/" + "normal-0";
  let str = "";
  if (lens === "普通") {
    str = "normal";
  } else if (lens === "广角") {
    str = "wide";
  } else if (lens === "缩放") {
    str = "zoom";
  } else if (lens === "红外") {
    str = "ir";
  } else {
    str = lens;
  }
  changeLivestreamLens({
    video_id: vedioId.value,
    video_type: str,
  }).then((res) => {
    if (res.code === 0) {
      // message.success('切换成功！')
      if (str != "wide") {
        onZoomFactorConfirm(true);
      }
    }
  });
};
// 切换  视频切换到相应的状态
const onSwitchVedio = (val: any) => {
  const lens = val;
  const sn = vedioSn.value;
  const type = vedioType.value;
  vedioId.value = sn + "/" + type + "/" + "normal-0";
  changeLivestreamLens({
    video_id: vedioId.value,
    video_type: lens,
  }).then((res) => {
    if (res.code === 0) {
    }
  });
};
// 变焦
async function onZoomFactorConfirm(confirm: boolean) {
  if (
    !zoomFactorPopoverData.zoomFactor ||
    zoomFactorPopoverData.cameraType === null
  ) {
    // message.error("请输入焦距");
    return;
  }
  if (confirm) {
    zoomFactor.value = zoomFactorValue(zoomFactorPopoverData.zoomFactor);
    zoomFactorPopoverData.loading = true;
    try {
      await changeCameraFocalLength(props.checkDockSn, {
        payload_index: payloadSelectInfo.payloadIndex,
        camera_type: zoomFactorPopoverData.cameraType,
        zoom_factor: zoomFactor.value,
      });
    } catch (err) {}
  }else{
    try {
      zoomFactor.value = zoomFactorPopoverData.zoomFactor
      await changeCameraFocalLength(props.checkDockSn, {
        payload_index: payloadSelectInfo.payloadIndex,
        camera_type: zoomFactorPopoverData.cameraType,
        zoom_factor: zoomFactorPopoverData.zoomFactor,
      });
    } catch (err) {}
  }
  zoomFactorPopoverData.visible = false;
}
// 焦距值 变化
function zoomFactorValue(val: number) {
  let num = 2;
  if (val >= 2 && val <= 40) {
    if (val == 2) {
      num = 2;
    } else if (val == 40) {
      num = 5;
    } else {
      num = Math.floor(val / 15) + 2;
    }
  }
  if (val > 40 && val <= 80) {
    if (val == 80) {
      num = 10;
    } else {
      num = Math.floor(val / 8);
    }
  }
  if (val > 80 && val <= 120) {
    if (val == 120) {
      num = 20;
    } else {
      num = Math.floor(val / 4);
    }
  }
  if (val > 120 && val <= 200) {
    if (val == 200) {
      num = 200;
    } else {
      num = Math.floor(val / 4) + 120;
    }
  }
  return num;
}
// 焦距 加、减的时候要先将视频切换到相应的状态
const onSwitchZoom = (val: any) => {
  const lens = val.type;
  zoomFactorPopoverData.cameraType = val.type;
  zoomFactorPopoverData.zoomFactor = val.num;
  const sn = vedioSn.value;
  const type = vedioType.value;
  vedioId.value = sn + "/" + type + "/" + "normal-0";
  changeLivestreamLens({
    video_id: vedioId.value,
    video_type: lens,
  }).then((res) => {
    if (res.code === 0) {
      onZoomFactorConfirm(false);
      // if (lens != "wide") {
      // }
    }
  });
};
// 相机，开始录像切换
function photoChange(val: boolean) {
  photoShow.value = val;
  onSwitchCameraMode();
}
// 变焦
async function onSwitchCameraMode() {
  if (!checkPayloadAuth(payloadSelectInfo.controlSource)) {
    return;
  }
  const currentCameraMode = payloadSelectInfo.camera?.camera_mode;
  await switchCameraMode(props.checkDockSn, {
    payload_index: payloadSelectInfo.payloadIndex,
    camera_mode:
      currentCameraMode === CameraMode.Photo
        ? CameraMode.Video
        : CameraMode.Photo,
  });
}
// 拍照
async function onTakeCameraPhoto() {
  if (!checkPayloadAuth(payloadSelectInfo.controlSource)) {
    return;
  }
  await takeCameraPhoto(props.checkDockSn, payloadSelectInfo.payloadIndex);
}
// 开始录像
async function onStartCameraRecording() {
  if (!checkPayloadAuth(payloadSelectInfo.controlSource)) {
    return;
  }
  await startCameraRecording(props.checkDockSn, payloadSelectInfo.payloadIndex);
  startVedio.value = false;
}
// 停止录像
async function onStopCameraRecording() {
  if (!checkPayloadAuth(payloadSelectInfo.controlSource)) {
    return;
  }
  await stopCameraRecording(props.checkDockSn, payloadSelectInfo.payloadIndex);
  startVedio.value = true;
}
// slider change节流 在一秒内只调用一次方法
const sliderFlag = ref<boolean>(true);
// 变焦sliderchange
function zoomSlider(val: any) {
  // console.log(1191, zoomFactorPopoverData.zoomFactor, val);
  if (!sliderFlag.value) {
    return false;
  }
  sliderFlag.value = false;
  zoomFactorPopoverData.zoomFactor = val;
  zoomFactorPopoverData.cameraType = cameraType.value;
  // onZoomFactorConfirm(true)
  if (vedioClick.value == 2) {
    setTimeout(() => {
      onSwitch1(cameraType.value);
      sliderFlag.value = true;
    }, 1000);
    // onZoomFactorConfirm(true)
  }
}
// 监听
stopWatchList.value.push(
watch(
  () => vedioClick.value,
  (val) => {
    if (val == 2) {
      startKeyVedio();
      reciveMittBus();
    } else {
      closeKeyVedio();
      mittBus.all.clear()
    }
  }
)
)
async function dbclickVedio(x: number, y: number) {
  await cameraAim(props.checkDockSn, {
    payload_index: payloadSelectInfo.payloadIndex,
    camera_type: cameraType.value,
    locked: false,
    x: x,
    y: y,
  });
}
// 是否可以进行下一次焦距操作，true为可以进行焦距操作，false不可以
const ornamentFlags = ref<boolean>(true);
  stopWatchList.value.push(
  watch(
    () => store?.state?.ornamentFlag,
    (val:any) => {    
      ornamentFlags.value = val?.success;
    },
    {
      deep: true,
    }
  )
  )
onUnmounted(()=>{
  if (stopWatchList.value) {
    stopWatchList.value.forEach((stopWatch:any) => stopWatch())
    stopWatchList.value = []
  }
})
// 映射
// 打开键盘事件
function startKeyVedio() {
  window.addEventListener("keydown", onVedioKeydown);
  // window.addEventListener('keyup', onVedioKeyup)
}
// 关闭键盘事件
function closeKeyVedio() {
  window.removeEventListener("keydown", onVedioKeydown);
  // window.addEventListener('keyup', onVedioKeyup)
}
// 键盘按下
function onVedioKeydown(e: KeyboardEvent) {
  // 负载控制
  if (e.key == "1") {
    onAuthPayload();
  }
  // 拍照
  if (e.key == "2") {
    // true为拍照
    if (photoShow.value) {
      onTakeCameraPhoto();
    } else {
      // true 为开始录像，false为停止录像
      if (startVedio.value) {
        onStartCameraRecording();
      } else {
        onStopCameraRecording();
      }
    }
  }
  // 云台回中
  if (e.key == "3") {
    gimbalClick(0);
  }
  // 上转动
  if (e.key == "4") {
    const x = 0.5;
    const y = 0.45;
    dbclickVedio(x, y);
  }
  // 下转动
  if (e.key == "5") {
    const x = 0.5;
    const y = 0.55;
    dbclickVedio(x, y);
  }
  // 右转动
  if (e.key == "6") {
    const x = 0.55;
    const y = 0.5;
    dbclickVedio(x, y);
  }
  // 左转动
  if (e.key == "7") {
    const x = 0.45;
    const y = 0.5;
    dbclickVedio(x, y);
  }
  // 拍照、录像切换
  if (e.key == "8") {
    photoShow.value = !photoShow.value;
    onSwitchCameraMode();
  }
  // 焦距归2
  if (e.key == "9") {
    // if (cameraType.value == 'wide') {
    //     message.warn('请选择变焦或红外')
    //     return
    //   }
    zoomFactorPopoverData.zoomFactor = 2;
    zoomFactorPopoverData.cameraType = cameraType.value;
    // onSwitch1(cameraType.value);
    const params = {
      type: cameraType.value,
      num: zoomFactorPopoverData.zoomFactor
    }
    onSwitchZoom(params);
  }
  // 焦距增加 1
  if (e.key == "m") {
    // if (cameraType.value == 'wide') {
    //     message.warn('请选择变焦或红外')
    //     return
    //   }
    if (!sliderFlag.value) {
      return false;
    }
    if (!ornamentFlags.value) {
      return
    }
    sliderFlag.value = false;
    setTimeout(() => {
      zoomFactorPopoverData.zoomFactor = zoomFactorPopoverData.zoomFactor + 1;
      zoomFactorPopoverData.cameraType = cameraType.value;
      // onSwitch1(cameraType.value);
      if (zoomFactorPopoverData.zoomFactor <= 2) {
        zoomFactorPopoverData.zoomFactor = 2
      }
      if (zoomFactorPopoverData.zoomFactor >= 200) {
        zoomFactorPopoverData.zoomFactor = 200
      }
      const params = {
      type: cameraType.value,
      num: zoomFactorPopoverData.zoomFactor
    }
    onSwitchZoom(params);
      sliderFlag.value = true;
    }, 100);
  }
  // 焦距减 1
  if (e.key == "n") {
    // if (cameraType.value == 'wide') {
    //     message.warn('请选择变焦或红外')
    //     return
    //   }
    if (!sliderFlag.value) {
      return false;
    }
    sliderFlag.value = false;
    setTimeout(() => {
      zoomFactorPopoverData.zoomFactor = zoomFactorPopoverData.zoomFactor - 1;
      zoomFactorPopoverData.cameraType = cameraType.value;
      if (zoomFactorPopoverData.zoomFactor <= 2) {
        zoomFactorPopoverData.zoomFactor = 2
      }
      if (zoomFactorPopoverData.zoomFactor >= 200) {
        zoomFactorPopoverData.zoomFactor = 200
      }
      // onSwitch1(cameraType.value);
      const params = {
      type: cameraType.value,
      num: zoomFactorPopoverData.zoomFactor
    }
    onSwitchZoom(params);
      sliderFlag.value = true;
        // 将mqttFlag值变为false
        store?.commit("SET_ORNA_FLAG", {
      num: zoomFactorPopoverData.zoomFactor,
      success: false
    });
    }, 100);
  }
  // 切换视频类型 广角、变焦、红外
  if (e.key == "k") {
    if (cameraType.value == "wide") {
      zoomNum.value = 1;
    }
    if (cameraType.value == "zoom") {
      zoomNum.value = 2;
    }
    if (cameraType.value == "ir") {
      zoomNum.value = 3;
    }
    // console.log('加+1',zoomNum.value);

    zoomNum.value++;
    if (zoomNum.value == 4) {
      zoomNum.value = 1;
    }
    // 广角
    if (zoomNum.value == 1) {
      onSwitchVedio("wide");
      cameraType.value = "wide";
    }
    // 变焦
    if (zoomNum.value == 2) {
      onSwitchVedio("zoom");
      cameraType.value = "zoom";
    }
    // 红外
    if (zoomNum.value == 3) {
      onSwitchVedio("ir");
      cameraType.value = "ir";
    }
    console.log(11533, cameraType.value);
  }
}
// 接受控制界面传过来的数据
function reciveMittBus() {
  // 视频角度
  mittBus.on("toVedio1", (e: any) => {
    // 如果当前选中的机场sn 与渲染视频的sn相同，且为负载相机的时候才能云台控制
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      // console.log(269,e);
      const dirs = e.lng;
      const type = e.type;
      cameraType.value = type
      if (dirs && dirs.length > 2) {
        const directions = dirs.substring(0, 2);
        let x = 0;
        let y = 0;
        if (directions == "up") {
          x = 0.5;
          y = 0.45;
        } else if (directions == "rh") {
          x = 0.55;
          y = 0.5;
        } else if (directions == "dw") {
          x = 0.5;
          y = 0.55;
        } else if (directions == "lf") {
          x = 0.45;
          y = 0.5;
        }
        dbclickVedio(x, y);
      }
    }
  });
  // 接受视频类型切换
  mittBus.on("vedioSwitch1", (e:any) => {
    // console.log(56666,checkPlanSns.value, props.dovkVedioSn);
    
    // 如果当前选中的机场sn 与渲染视频的sn相同，且为负载相机的时候才能切换
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      onSwitchVedio(e.vedioType);
      cameraType.value = e.vedioType;
    }
  });
  // 拍照 录像切换 true为拍照 false为录像
  mittBus.on("photoChange1", (e: any) => {
    // 如果当前选中的机场sn 与渲染视频的sn相同，且为负载相机的时候才能切换
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      photoShow.value = !photoShow.value;
      onSwitchCameraMode();
    }
  });
  // 拍照
  mittBus.on("takePhoto1", (e: any) => {
    // 如果当前选中的机场sn 与渲染视频的sn相同，且为负载相机的时候才能拍照
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      // photoShow.value = true
      onTakeCameraPhoto();
    }
  });
  // 开始录像
  mittBus.on("startRecord1", (e: any) => {
    // 如果当前选中的机场sn 与渲染视频的sn相同，且为负载相机的时候才能开始录像
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      onStartCameraRecording();
      startVedio.value = false
    }
  });
  // 结束录像
  mittBus.on("stopRecord1", (e: any) => {
    // 如果当前选中的机场sn 与渲染视频的sn相同，且为负载相机的时候才能结束录像
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      onStopCameraRecording();
      startVedio.value = true
    }
  });
  // 云台控制
  mittBus.on("gimbalClick1", (e: any) => {
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      gimbalClick(e.val);
    }
  });
  // 焦距改变
  mittBus.on("zoomchange1", (e: any) => {    
    if (e.checkPlanSn == props.checkPlaneSn && vedioClick.value == 2) {
      onSwitchZoom(e);
    }
  });
}
</script>
<style scoped lang="scss">
.map-vedio-box {
  width: 100%;
  height: 100%;
  &:deep(.ant-spin-nested-loading) {
    height: 100%;
  }
  &:deep(.ant-spin-container) {
    height: 100%;
  }
}
.icon-box{
  padding: 0 7px;
  background: rgba(89, 89, 89, 0.6);
  &:hover {
      background: #1890ff;
  }
}
// 切换视频
.load-vedio {
  position: absolute;
  top: 6px;
  left: 50%;
  // right: 60px;
  // right: 120px;
  transform: translateX(-50%);
  // width: 300px;
  // width: 60%;
  display: flex;
  height: 18px;
  line-height: 18px;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  z-index: 102;
  .load-vedio-item {
    // flex: 1;
    // width: ;
    display: flex;
    height: 18px;
    line-height: 18px;
    // width: 36px;
    // height: 36px;
    border-radius: 2px;
    padding: 0 7px;
    justify-content: center;
    align-items: center;
    background: rgba(89, 89, 89, 0.6);
    // background: #595959;
    cursor: pointer;
    font-size: 12px;
    color: #fff;
    &:hover {
      background: #1890ff;
    }
    // div{
    //     display: flex;
    //     justify-self: center;
    //     align-content: center;
    //     img{
    //         width: 28px;
    //         height: 28px;
    //     }
    // }
  }
}

.load-top-left {
  text-align: right;
  font-size: 16px;
  position: absolute;
  top: 2px;
  left: 60px;
  z-index: 102;
  color: #fff;
}
// 清晰度
.load-top {
  text-align: right;
  font-size: 16px;
  position: absolute;
  top: 2px;
  right: 15px;
  z-index: 102;
  color: #fff;
  .claritybox {
    cursor: pointer;
    color: #fff !important;
    span {
      &:hover {
        color: #5cadff;
      }
    }
    .select-clarity {
      color: #5cadff;
    }
  }
}
.mb8 {
  margin-bottom: 8px;
}
.zoom-btn {
  height: 20px;
  font-size: 12px;
  border-radius: 2px;
  border: 1px solid #fff;
  color: #fff;
  background: transparent !important;
  padding: 0 7px;
  cursor: pointer;
  &:hover {
    color: #40a9ff;
    border-color: #40a9ff;
  }
}
.zoom-btn-active {
  color: #40a9ff;
  border-color: #40a9ff;
}
// 测距距离
.measure-distance {
  position: absolute;
  bottom: 10px;
  left: 40px;
  color: #fff;
  font-size: 12px;
}
// 负载控制
.load-auth {
  position: absolute;
    top: 4px;
    right: 120px;
    // right: 85px;
    z-index: 102;
}
// 云台控制
.gimbal-box {
  position: absolute;
  left: 12px;
  bottom: 30px;
  .gimbal-option {
    margin-bottom: 10px;
    .gimbal-option-item {
      background: #595959;
      margin-bottom: 2px;
    }
  }
}
// 变焦
.zoom-box {
  position: absolute;
  left: 12px;
  top: 25%;
  &:deep(.ant-btn-sm) {
    padding: 0px 3px;
  }
}
// 拍照
.load-right {
  position: absolute;
  right: 12px;
  top: 55px;
}
.zoom-slider {
  position: absolute;
  bottom: 20px;
  right: 13px;
  height: 50%;
  &:deep(.ant-slider-mark) {
    font-size: 12px;
    left: 6px;
  }
  &:deep(.ant-slider-rail){
    width: 2px;
  }
  &:deep(.ant-slider-dot){
    width: 4px;
    height: 4px;
    margin-left: -3px;
  }
  &:deep(.ant-slider-handle){
    width: 8px;
    height: 8px;
  }
  &:deep(.ant-slider-vertical .ant-slider-handle){
    margin-left: -3px;
  }
  &:deep(.ant-slider-vertical .ant-slider-track){
    width: 2px;
  }

}
.zoom-factor {
  position: absolute;

  color: #fff;
  left: -30px;
  padding: 5px 10px;
  background: #333;
}
.no-vedio {
  width: 100%;
  height: 300px;
  font-size: 20px;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: center;
  font-weight: 600;
  letter-spacing: 2px;
}
// 工地名称
.construction-box1{
  position: absolute;
  top: 33px;
  width: 100%;
  z-index: 101;
  .construction-item-box1{
    width: 100%;
    // margin: 0 auto;
    .construction-item1{
      width: 60%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: red;
    }
  }
}
// x 坐标系
.coordinate-system-box-x1 {
  position: absolute;
  bottom: 30px;
  // left: 80px;
  width: 100%;
  z-index: 101;
  .coordinate-system1 {
    position: relative;
    width: 60%;
    margin-left: 90px;
    height: 10px;
    font-size: 12px;
    .x-axis1 {
      position: absolute;
      bottom: 0;
      left: 0;
      background: #fff;
      width: 100%;
      height: 2px;
    }
    .x-tickmarks1 {
      position: absolute;
      // left: 20px;
      bottom: -20px;
      color: #fff;
      &:before {
        content: "";
        // color: #fff;
        position: absolute;
        width: 1px;
        height: 10px;
        background-color: #fff;
        bottom: 20px;
        left: 0px;
      }
      &:after {
        content: "°";
        // color: #fff;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(100%);
      }
    }
    .x-tickmarks-z1 {
      position: absolute;
      // left: 20px;
      bottom: -20px;
      color: #fff;
      &:before {
        content: "";
        // color: #fff;
        position: absolute;
        width: 1px;
        height: 15px;
        background-color: #fff;
        bottom: 20px;
        left: 0px;
      }
      &:after {
        content: "°";
        // color: #fff;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(100%);
      }
    }
    .x-tickmarks-active1 {
      position: absolute;
      bottom: 15px;
      color: #fff;
      &:before {
        content: "";
        position: absolute;
        bottom: -11px;
        left: -10px;
        width: 0;
        height: 0;
        border-top: 8px solid #29A2FF;
        border-right: 8px solid transparent;
        border-left: 8px solid transparent;
      }
      &:after {
        content: "°";
        // color: #fff;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(100%);
      }
    }
  }
}
// y 坐标系
.coordinate-system-box-y1 {
  position: absolute;
  left: 90px;
  top: 0;
  // left: 80px;
  height: 100%;
  z-index: 101;
  transition: all 0.5s;
  .coordinate-system-y1 {
    position: relative;
    height: 60%;
    // margin-bottom: 10%;
    width: 10px;
    font-size: 12px;
    .y-axis1 {
      position: absolute;
      bottom: 0;
      left: 0;
      background: #fff;
      height: 100%;
      width: 2px;
    }
    .y-tickmarks1 {
      position: absolute;
      left: -30px;
      color: #fff;
      line-height: 0;
      width: 25px;
      text-align: right;
      padding-right: 5px;
      &:before {
        content: "";
        // color: #fff;
        position: absolute;
        height: 1px;
        width: 10px;
        background-color: #fff;
        bottom: 0px;
        left: 30px;
      }
    }
    .y-tickmarks-z1 {
      position: absolute;
      left: -30px;
      color: #fff;
      line-height: 0;
      width: 25px;
      text-align: right;
      padding-right: 5px;
      &:before {
        content: "";
        // color: #fff;
        position: absolute;
        height: 1px;
        width: 15px;
        background-color: #fff;
        bottom: 0px;
        left: 30px;
      }
    }
    .y-tickmarks-active1 {
      position: absolute;
      left: 15px;
      color: #fff;
      line-height: 0;
      /* width: 25px; */
      text-align: left;
      padding-left: 5px;
      &:before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-top: 8px solid #29A2FF;
        border-right: 8px solid transparent;
        border-left: 8px solid transparent;
        bottom: -5px;
        left: -10px;
        transform: rotate(90deg);
      }
    }
    .y-num-txts1 {
      position: relative;
      &:after {
        content: "°";
        // color: #fff;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(100%);
      }
    }
  }
}
</style>